(function () {

    "use strict";

    console.log("warranty.js loaded");

    const productsContainer = document.getElementById("productsContainer");
    const btnAddProduct = document.getElementById("btnAddProduct");
    const btnClearProducts = document.getElementById("btnClearProducts");
    var API_URL = "https://booking-api.robamnz-it.workers.dev/";

    if (!productsContainer) return;

    btnAddProduct?.addEventListener("click", addProduct);
    btnClearProducts?.addEventListener("click", clearProducts);

    productsContainer.addEventListener("click", function (e) {

        if (e.target.closest(".btnRemoveProduct")) {

            removeProduct(e.target.closest(".btnRemoveProduct"));

        }

    });

    //--------------------------------------------------------
    // Add Product
    //--------------------------------------------------------

    function addProduct() {

        const template = productsContainer.querySelector(".warranty-product");

        if (!template) return;

        const clone = template.cloneNode(true);

        clearCard(clone);

        productsContainer.appendChild(clone);

        updateProducts();

    }

    //--------------------------------------------------------
    // Remove Product
    //--------------------------------------------------------

    function removeProduct(button) {

        const cards = productsContainer.querySelectorAll(".warranty-product");

        if (cards.length <= 1) {

            alert("At least one product is required.");
            return;

        }

        button.closest(".warranty-product").remove();

        updateProducts();

    }

    //--------------------------------------------------------
    // Clear All
    //--------------------------------------------------------

    function clearProducts() {

        const template = productsContainer.querySelector(".warranty-product");

        if (!template) return;

        const clone = template.cloneNode(true);

        clearCard(clone);

        productsContainer.innerHTML = "";

        productsContainer.appendChild(clone);

        updateProducts();

    }

    //--------------------------------------------------------
    // Clear Inputs
    //--------------------------------------------------------

    function clearCard(card) {

        card.querySelectorAll("input").forEach(function (input) {

            switch (input.type) {

                case "checkbox":
                case "radio":
                    input.checked = false;
                    break;

                case "button":
                case "submit":
                case "hidden":
                    break;

                default:
                    input.value = "";
                    break;

            }

        });

        card.querySelectorAll("select").forEach(function (select) {

            select.selectedIndex = 0;

        });

        card.querySelectorAll("textarea").forEach(function (textarea) {

            textarea.value = "";

        });

    }

    //--------------------------------------------------------
    // Update Numbering
    //--------------------------------------------------------

    function updateProducts() {

        const cards = productsContainer.querySelectorAll(".warranty-product");

        cards.forEach(function (card, index) {

            const no = index + 1;

            card.dataset.product = no;

            //--------------------------------------------------
            // Title
            //--------------------------------------------------

            const title = card.querySelector(".warranty-product__title");

            if (title) {

                title.textContent = "Product #" + no;

            }

            //--------------------------------------------------
            // IDs
            //--------------------------------------------------

            card.querySelectorAll("[id]").forEach(function (element) {

                element.id = element.id.replace(/[0-9]+$/, "") + no;

            });

            //--------------------------------------------------
            // Labels
            //--------------------------------------------------

            card.querySelectorAll("label[for]").forEach(function (label) {

                label.htmlFor = label.htmlFor.replace(/[0-9]+$/, "") + no;

            });

            //--------------------------------------------------
            // Remove Button
            //--------------------------------------------------

            const removeButton = card.querySelector(".btnRemoveProduct");

            if (removeButton) {

                removeButton.style.display =
                    cards.length === 1 ? "none" : "";

            }

        });

    }

    //--------------------------------------------------------
    // Initialize
    //--------------------------------------------------------

    document.addEventListener("DOMContentLoaded", function () {
        updateProducts();

        // Purchase Date
        populateDays("ddlPurchaseDay");
        populateYears("ddlPurchaseYear");

        // Installation Date
        populateDays("ddlInstallationDay");
        populateYears("ddlInstallationYear");
    });

    //--------------------------------------------------------
    // Initialize Date Dropdowns
    //--------------------------------------------------------

    function populateDays(selectId) {
        const ddl = document.getElementById(selectId);

        if (!ddl) return;

        ddl.innerHTML = '<option value="">Day</option>';

        for (let i = 1; i <= 31; i++) {
            const option = document.createElement("option");
            option.value = i.toString().padStart(2, "0");
            option.textContent = i;
            ddl.appendChild(option);
        }
    }

    function populateYears(selectId) {
        const ddl = document.getElementById(selectId);

        if (!ddl) return;

        ddl.innerHTML = '<option value="">Year</option>';

        const currentYear = new Date().getFullYear();

        // Allow the last 20 years
        for (let year = currentYear; year >= currentYear - 20; year--) {
            const option = document.createElement("option");
            option.value = year;
            option.textContent = year;
            ddl.appendChild(option);
        }
    }
    
    //--------------------------------------------------------
    // Submit
    //--------------------------------------------------------

    const btnSubmit = document.getElementById("btnSubmit");

    if (btnSubmit) {

            btnSubmit.addEventListener("click", function (e) {

                e.preventDefault();

                if (btnSubmit.disabled)
                    return;

                // Validate FIRST
                if (!validateWarranty()) {
                    return;
                }

                // Only show spinner if validation passed
                btnSubmit.disabled = true;
                btnSubmit.querySelector(".btn-text").textContent =
                    "Submitting...";
                btnSubmit.querySelector(".btn-spinner")
                    .classList.remove("hidden");

                submitWarranty();

            });

        }

    //--------------------------------------------------------
    // Invoice Upload
    //--------------------------------------------------------

    const invoiceInput =
        document.getElementById("fileInvoice");

    if (invoiceInput) {

        invoiceInput.addEventListener(
            "change",
            function () {

                const fileName =
                    document.getElementById("fileInvoiceName");

                if (!fileName)
                    return;

                fileName.textContent =
                    this.files.length > 0
                        ? this.files[0].name
                        : "No file selected";

            });

    }

        //--------------------------------------------------------
    // Collect Products
    //--------------------------------------------------------

    function getProducts() {

        const products = [];

        document
            .querySelectorAll(".warranty-product")
            .forEach(function (card) {

                products.push({

                    productType:
                        card.querySelector("[data-field='productType']").value,

                    productModel:
                        card.querySelector("[data-field='productModel']").value.trim(),

                    serialNumber:
                        card.querySelector("[data-field='serialNumber']").value.trim()

                });

            });

        return products;

    }

        //--------------------------------------------------------
    // Checkbox Values
    //--------------------------------------------------------

    function getCheckedValues(container) {

        const values = [];

        container
            .querySelectorAll("input[type='checkbox']:checked")
            .forEach(function (checkbox) {

                values.push(
                    checkbox.value
                );

            });

        return values;

    }

        //--------------------------------------------------------
    // Radio Value
    //--------------------------------------------------------

    function getRadioValue(name) {

        const radio =
            document.querySelector(
                "input[name='" + name + "']:checked"
            );

        return radio
            ? radio.value
            : "";

    }

        //--------------------------------------------------------
    // Collect Warranty Data
    //--------------------------------------------------------

    function getWarrantyData() {

        return {

            salutation:
                document.getElementById("ddlSalutation").value,

            customerName:
                document.getElementById("txtCustomerName").value.trim(),

            race:
                document.getElementById("ddlRace").value,

            icNumber:
                document.getElementById("txtIcNumber").value.trim(),

            passportNumber:
                document.getElementById("txtPassportNumber").value.trim(),

            mobile:
                document.getElementById("txtMobile").value.trim(),

            email:
                document.getElementById("txtEmail").value.trim(),

            address:
                document.getElementById("txtAddress").value.trim(),

            city:
                document.getElementById("txtCity").value.trim(),

            postcode:
                document.getElementById("txtPostcode").value.trim(),

            homeTelephone:
                document.getElementById("txtHomeTelephone").value.trim(),

            dealerName:
                document.getElementById("ddlDealerName").value,

            purchaseDay:
                document.getElementById("ddlPurchaseDay").value,

            purchaseMonth:
                document.getElementById("ddlPurchaseMonth").value,

            purchaseYear:
                document.getElementById("ddlPurchaseYear").value,

            installationDay:
                document.getElementById("ddlInstallationDay").value,

            installationMonth:
                document.getElementById("ddlInstallationMonth").value,

            installationYear:
                document.getElementById("ddlInstallationYear").value,

            invoiceNumber:
                document.getElementById("txtInvoiceNumber").value.trim(),

            deliveryOrderNumber:
                document.getElementById("txtDeliveryOrderNumber").value.trim(),

            houseType:
                document.getElementById("ddlHouseType").value,

            renovation:
                getRadioValue("renovation"),

            marketingConsent:
                getRadioValue("marketingConsent"),

            preferredChannels:
                getCheckedValues(
                    document.getElementById("preferredChannelsGroup")
                ),

            hearAboutRobam:
                getCheckedValues(
                    document.getElementById("hearAboutGroup")
                ),

            purchaseReason:
                getCheckedValues(
                    document.getElementById("purchaseReasonGroup")
                ),

            acceptTerms:
                document.getElementById("chkTerms").checked,

            acceptPdpa:
                document.getElementById("chkPdpa").checked,

            products:
                getProducts()

        };

    }

    //--------------------------------------------------------
    // Validation
    //--------------------------------------------------------

    function validateWarranty() {

    //--------------------------------------------------------
    // Required Fields
    //--------------------------------------------------------

    const requiredFields =
        document.querySelectorAll("[data-required='true']");

    for (let i = 0; i < requiredFields.length; i++) {

        const field = requiredFields[i];

        if (field.type === "checkbox") {

            if (!field.checked) {

                alert("Please accept all required terms.");

                field.focus();

                return false;

            }

        } else {

            if (field.value.trim() === "") {

                const label =
                    field.closest(".field")
                        ?.querySelector(".field__label");

                alert(
                    "Please complete " +
                    (label
                        ? label.innerText.replace("*", "").trim()
                        : "all required fields.")
                );

                field.focus();

                return false;

            }

        }

    }

    //--------------------------------------------------------
    // New Zealand Mobile Validation
    //--------------------------------------------------------

    const mobile =
        document.getElementById("txtMobile").value.trim();

    // Accepts:
    // 0211234567
    // 021 123 4567
    // 021-123-4567
    // +64 21 123 4567
    // +64211234567
    const nzMobileRegex =
        /^(?:\+64\s?|0)2\d(?:[\s-]?\d){6,8}$/;

    if (!nzMobileRegex.test(mobile)) {

        alert(
            "Please enter a valid New Zealand mobile number (e.g. 021 123 4567)."
        );

        document.getElementById("txtMobile").focus();

        return false;

    }

    //--------------------------------------------------------
    // Email Validation
    //--------------------------------------------------------

    const email =
        document.getElementById("txtEmail").value.trim();

    const emailRegex =
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (!emailRegex.test(email)) {

        alert("Please enter a valid email address.");

        document.getElementById("txtEmail").focus();

        return false;

    }

    //--------------------------------------------------------
    // Purchase Date Validation (Required)
    //--------------------------------------------------------

    if (
        !document.getElementById("ddlPurchaseDay").value ||
        !document.getElementById("ddlPurchaseMonth").value ||
        !document.getElementById("ddlPurchaseYear").value
    ) {

        alert("Please select the complete Purchase Date.");

        document.getElementById("ddlPurchaseDay").focus();

        return false;

    }

    //--------------------------------------------------------
    // Installation Date Validation (Optional)
    // If any installation field is selected, require all three.
    //--------------------------------------------------------

    const installationDay =
        document.getElementById("ddlInstallationDay").value;

    const installationMonth =
        document.getElementById("ddlInstallationMonth").value;

    const installationYear =
        document.getElementById("ddlInstallationYear").value;

    const installationSelected =
        installationDay || installationMonth || installationYear;

    if (
        installationSelected &&
        (!installationDay || !installationMonth || !installationYear)
    ) {

        alert("Please complete the Installation Date or leave it blank.");

        document.getElementById("ddlInstallationDay").focus();

        return false;

    }

    //--------------------------------------------------------
    // Product Validation
    //--------------------------------------------------------

    const products = getProducts();

    for (const product of products) {

        if (
            !product.productType ||
            !product.productModel ||
            !product.serialNumber
        ) {

            alert("Please complete all product information.");

            return false;

        }

    }

    return true;

}

    //--------------------------------------------------------
    // Submit Warranty
    //--------------------------------------------------------

    function submitWarranty() {

    if (!validateWarranty()) {
  
        return;
    }

    const data = getWarrantyData();

    const formData = new FormData();

    formData.append("action", "submit");
    formData.append("formType", "warranty");

    formData.append("Salutation", data.salutation);
    formData.append("CustomerName", data.customerName);
    formData.append("Race", data.race);
    formData.append("ICNumber", data.icNumber);
    formData.append("PassportNumber", data.passportNumber);
    formData.append("Mobile", data.mobile);
    formData.append("Email", data.email);
    formData.append("Address", data.address);
    formData.append("State", data.state);
    formData.append("City", data.city);
    formData.append("Postcode", data.postcode);
    formData.append("HomeTelephone", data.homeTelephone);

    formData.append("DealerName", data.dealerName);

    if (
        !data.purchaseYear ||
        !data.purchaseMonth ||
        !data.purchaseDay
    ) {
        alert("Please select the complete Purchase Date.");
        return;
    }

    const purchaseDate =
        `${data.purchaseYear}-${data.purchaseMonth}-${data.purchaseDay}`;

    console.log("PurchaseDate:", purchaseDate);

    formData.append(
        "PurchaseDate",
        purchaseDate
    );

    //--------------------------------------------------------
    // Installation Date (optional)
    //--------------------------------------------------------

    console.log("Installation raw values:", {
        day: data.installationDay,
        month: data.installationMonth,
        year: data.installationYear
    });

    const installationDay = data.installationDay || "";
    const installationMonth = data.installationMonth || "";
    const installationYear = data.installationYear || "";

    if (
        installationDay !== "" &&
        installationMonth !== "" &&
        installationYear !== ""
    ) {

        const installationDate =
            `${installationYear}-${installationMonth}-${installationDay}`;

        console.log("InstallationDate generated:", installationDate);

        formData.append(
            "InstallationDate",
            installationDate
        );

    } else {

        console.log("InstallationDate not appended");

    }

    formData.append("InvoiceNumber", data.invoiceNumber);
    formData.append("DeliveryOrderNumber", data.deliveryOrderNumber);

    formData.append(
        "HearAboutRobam",
        data.hearAboutRobam.join(", ")
    );

    formData.append(
        "PurchaseReason",
        data.purchaseReason.join(", ")
    );

    formData.append("HouseType", data.houseType);
    formData.append("Renovation", data.renovation);
    formData.append("MarketingConsent", data.marketingConsent);

    formData.append(
        "PreferredChannels",
        data.preferredChannels.join(", ")
    );

    formData.append(
        "ProductsJson",
        JSON.stringify(data.products)
    );

    formData.append(
        "ProductCount",
        data.products.length
    );

    const invoice =
        document.getElementById("fileInvoice");

    if (invoice.files.length > 0) {

        formData.append(
            "InvoiceFile",
            invoice.files[0]
        );

    }

    //--------------------------------------------------------
    // Log all FormData entries
    //--------------------------------------------------------

    console.log("=== FormData Entries ===");

    for (const pair of formData.entries()) {
        console.log(pair[0] + ":", pair[1]);
    }

    const xhr =
        new XMLHttpRequest();

    xhr.open(
        "POST",
        API_URL,
        true
    );

    document.getElementById("btnSubmit").disabled = true;

    xhr.onload = function () {

        console.log("XHR Status:", xhr.status);
        console.log("XHR Response:", xhr.responseText);

        const btn =
            document.getElementById("btnSubmit");

        btn.disabled = false;

        btn.querySelector(".btn-text").textContent =
            "Submit Warranty Registration";

        btn.querySelector(".btn-spinner")
            .classList.add("hidden");

        if (xhr.status >= 200 && xhr.status < 300) {

            let response;

            try {
                response = JSON.parse(xhr.responseText);
            } catch {
                response = {};
            }

            if (response.success || response.status === "success") {

                alert("Warranty registration submitted successfully.");

                window.location.href = "/pages/thank-you";

            } else {

                alert(response.message || "Submission failed.");

            }

        } else {

            alert("Unable to submit warranty registration.");

        }

    };

    xhr.onerror = function () {

        console.error("XHR Network Error");

        const btn =
            document.getElementById("btnSubmit");

        btn.disabled = false;

        btn.querySelector(".btn-text").textContent =
            "Submit Warranty Registration";

        btn.querySelector(".btn-spinner")
            .classList.add("hidden");

        alert("Network error. Please try again.");

    };

    xhr.send(formData);

}



})();